/**
 * Etichetta del pulsante mentre il modello lavora.
 *
 * Il ragionamento occupa la prima metà dell'attesa e non produce testo: senza
 * un'etichetta che lo dica il pannello sembra bloccato, ed e' il momento in cui
 * la redazione ripremeva il pulsante.
 */
export function etichettaAvanzamento(stato: { caratteriScritti: number; sta: 'ragionando' | 'scrivendo' } | null): string {
  if (stato === null || stato.sta === 'ragionando') {
    return 'Ragiono...';
  }
  return `Scrivo... ${conSeparatore(stato.caratteriScritti)} caratteri`;
}

/**
 * Migliaia separate dal punto. Scritto a mano invece di toLocaleString: quello
 * dipende dai dati di localizzazione del browser, che in un headless possono
 * mancare, e allora il numero uscirebbe senza separatore.
 */
function conSeparatore(numero: number): string {
  return String(numero).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}
